<template>
        <!-- Contact-->
    <section id="contact" class="contact-section bg-black">
        <div class="container" data-aos="fade-down">
            <div class="row" style="font-family: 'Rubik', sans-serif !important">
                <div class="col-md-4 mb-3 mb-md-0">
                    <div class="card py-4 h-100">
                        <div class="card-body text-center">
                            <i class="fas fa-map-marked-alt text-primary mb-2"></i>
                            <h4 class="text-uppercase m-0">Address</h4>
                            <hr class="my-4" />
                            <div class="small text-black-50">Tangerang, Indonesia</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                    <div class="card py-4 h-100">
                        <div class="card-body text-center">
                            <i class="fas fa-envelope text-primary mb-2"></i>
                            <h4 class="text-uppercase m-0">Email</h4>
                            <hr class="my-4" />
                            <div class="small text-black-50"><a href="mailto:miskahalfiyyah12@gmail.com">miskahalfiyyah12@gmail.com</a></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                    <div class="card py-4 h-100">
                        <div class="card-body text-center">
                            <i class="fas fa-mobile-alt text-primary mb-2"></i>
                            <h4 class="text-uppercase m-0">Phone</h4>
                            <hr class="my-4" />
                            <div class="small text-black-50">0812-xxxx-xxxx</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="social d-flex justify-content-center">
                <a class="mx-2" target="_blank" href="https://twitter.com/miskalfyyh_"><i
                        class="fab fa-twitter"></i></a>
                <a class="mx-2" target="_blank" href="https://www.instagram.com/miskalfyyh/"><i
                        class="fab fa-instagram"></i></a>
                <a class="mx-2" target="_blank" href="https://dribbble.com/miskalfyyh"><i
                        class="fab fa-dribbble"></i></a>
                <a class="mx-2" target="_blank" href="https://www.linkedin.com/in/miskahalfiyyah/"><i
                        class="fab fa-linkedin-in"></i></a>
                <a class="mx-2" target="_blank" href="https://github.com/miskahalfiyyah"><i
                        class="fab fa-github"></i></a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name:' ContactMe'
}
</script>